<div></div>
<span></span>

<style>
  div, span {
    position: absolute;
    top: 5%;
    right: 0;
    bottom: 5%;
    left: 0;
    margin: auto;
    max-width: min(90vw, 70rem);
    border: 1px solid var(--fg-1);
    border-radius: 50%;
    pointer-events: none;
  }
  
  div {
    transform: translate(5%, 2.5%);
  }
  
  span {
    transform: translate(-5%, 5%);
  }
</style>